import Webinars from './Webinars.vue';

export default Webinars;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/views/webinars/index.ts